import React from 'react';

import { JackpotDetailsSection } from '../jackpot-details-section';
import { useTranslation } from '../../../../../../hooks';
import { T } from '../../../../../../constants';

interface JackpotDetailsDescriptionProps {

}

export const JackpotDetailsDescription: React.FC<JackpotDetailsDescriptionProps> = () => {

  const t = useTranslation();

  return (
    <JackpotDetailsSection title={t(T.JACKPOT_RULES)}>
      <p
        className="jackpot-info-txt"
        dangerouslySetInnerHTML={{ __html: t(T.RICH_JACKPOT_RULES_DESCRIPTION) }}
      />
    </JackpotDetailsSection>
  );
};
